module.exports = __webpack_public_path__ + "img/maxG.a2d86380.svg";